module.exports = __webpack_public_path__ + "img/blue_butterfly.9b13f0be.jpg";